import Component from "../component";
import { getLocale } from "../../helpers/locale";
import { replace } from "../../utils/utils";
import { getConfig } from "../../configuration/config";

export interface IRouteRoadbook {
    route: woosmap.map.transit.TransitRoute | undefined;
    origin?: string;
    destination?: string;
    totalDistance?: number;
    totalDuration?: number;
    summary?: string;
}

export enum TransitRoadbookComponentEvents {
    BACK = "back",
}

export default class TransitRoadbookComponent extends Component<IRouteRoadbook> {
    init(): void {
        if(this.$target.children.length > 0){
            const node = this.$target.children[0]
            this.$target.removeChild(node);
        }
        this.$element = <HTMLDivElement>document.createElement("div");
        this.$element.className = "trouteRoadbook";
        this.$target.appendChild(this.$element);
    }

    render(): void {
        if(this.$target.children.length > 0){
           this.init();
        }
        if (this.state && this.$element && this.state.route) {
            const originText = `${this.state.origin}`
            const destinationText = `${this.state.destination}`

            const $roadbookHeader: HTMLDivElement = document.createElement("div");
            $roadbookHeader.className = "trouteRoadbook__header"
            $roadbookHeader.innerHTML = `
                                <span class="trouteRoadbook__headerFromTo">
                                    <div class="trouteRoadbook__headerWaypoint"> ${getLocale().directions.messages.from} <span class="routeRoadbook__headerFrom">${originText}</span></div>
                                    <div class="trouteRoadbook__headerWaypoint"> ${getLocale().directions.messages.to} <span class="routeRoadbook__headerTo">${destinationText}</span></div>
                                </span>`;
            const $roadbookBody: HTMLDivElement = document.createElement("div");
            $roadbookBody.className = "trouteRoadbook__body"
            $roadbookBody.innerHTML = `
            <div class="trouteRoadbook__summaryHeader">
              <span>
                <span class="delay" >${this.formatTime(this.state.totalDuration)} </span>
                <span class="trouteRoadbook__summarySubtitle">(<span >${this.formatDistance(this.state.totalDistance)}</span>)</span>
              </span>
              <span class="trouteRoadbook__summaryDescription">${getLocale().directions.messages.via} ${this.state.summary}</span>
            </div>`;
            const $instructions: HTMLDivElement = document.createElement("div");
            $instructions.className = "trouteRoadbook__steps";
            this.state.route.legs.forEach(leg => {
                const $leg: HTMLDivElement = document.createElement("div");
                $leg.className = "route";
                $leg.innerHTML = `
                <div style="${leg.travel_mode === `pedestrian` ? "background-color: #1aae1d" : `background-color: ${leg.transport.color ? leg.transport.color : `#c0bfbf`}`}" class="icon ${leg.travel_mode === `pedestrian` ? `pedestrian` : this.getTransitMode(leg.transport.mode)}"></div>
                <div class="details">
                    ${leg.travel_mode === "pedestrian" ?
                        `<span>${getLocale().directions.messages.walk}</span><div class='subdetails' style='border-left: 3px dashed #1aae1d'>` :
                        `<span>${getLocale().directions.messages.take} ${getLocale().directions.messages.the} ${this.getTransitMode(leg.transport.mode)}</span>
                    <div class="subdetails" style="border-left: 3px solid ${leg.transport.color ? leg.transport.color : `#c0bfbf`}"><p><span class='line'>${leg.transport.name}</span> ${leg.transport.headsign}</p>`
                    }
                    ${leg.travel_mode === "pedestrian" ?
                        "<span></span>" :
                        `<p class='line'>${getLocale().directions.messages.from} ${leg.start_location.name} > ${getLocale().directions.messages.to} ${leg.end_location.name}</p>`
                    }
                   
                    <span class="duration">${this.formatTime(leg.duration)}</span>
                    <span class="time">${this.formatDistance(leg.distance)}</span>
                    <div class="divider"></div><div>
                </div>
                `;
                $instructions.appendChild($leg);
            });
            $roadbookBody.appendChild($instructions);
            const $backBtn: HTMLButtonElement = document.createElement("button");
            $backBtn.className = "trouteRoadbook__headerBack";
            $backBtn.addEventListener("click", () => this.emit(TransitRoadbookComponentEvents.BACK));
            $roadbookHeader.prepend($backBtn);
            // $roadbookBody.appendChild(this.getHTMLInstructions());
            this.$element.replaceChildren(...[$roadbookHeader, $roadbookBody]);
            this.styleOnScroll($roadbookBody);
        }
    }
    unMount(): void {
        if(this.$element){
            this.$target.removeChild(this.$element);
        }
        
    }
    getDirectionGoogleMapsUrl(latlng: woosmap.map.LatLngLiteral): string {
        return `https://www.google.fr/maps/dir//${latlng.lat},${latlng.lng}`;
    }

    getDirectionStepIcon(action?: number): string {
        if (action) {
            const stepIconObj = getConfig().directions.stepsIcon.filter(({ index }) => index === action)[0];
            if (stepIconObj) {
                const className = (stepIconObj.key as string).endsWith('Right') ? "reverse" : "";
                return `<div class="trouteRoadbook__stepIcon routeRoadbook__stepIcon${className}">
                            <img alt="${stepIconObj.key}" src="${stepIconObj.icon}">
                        </div>`;
            } else {
                return `<div class="trouteRoadbook__stepIcon routeRoadbook__stepIcon${action}"></div>`;
            }
        }
        return "";
    }

    getDirectionInstructionStep(instructions?: woosmap.map.DirectionStepInstructions): string {
        if (instructions) {
            if (instructions.summary) {
                return `<div class="trouteRoadbook__stepBody">
                            <span>${instructions.summary}</span>
                        </div>`;
            }
        }
        return "";
    }

    getDirectionInstructionDistance(distance?: string): HTMLDivElement {
        const $distanceSeperator: HTMLDivElement = document.createElement("div");
        if (distance) {
            $distanceSeperator.className = "trouteRoadbook__stepDistance";
            $distanceSeperator.innerHTML = `<div class="trouteRoadbook__stepDistanceSeparator"></div>
                    <div class="trouteRoadbook__stepDistanceText">${distance}</div>`;
        }
        return $distanceSeperator;
    }

    getWaypoint(address: string): HTMLDivElement {
        const $waypoint: HTMLDivElement = document.createElement("div");
        $waypoint.className = "trouteRoadbook__waypoint"
        $waypoint.innerHTML = `<span><h4 class="routeRoadbook__waypointAddress">${address}</h4></span>`;
        return $waypoint;
    }


    getHTMLInstructions(): HTMLDivElement {
        const $instructions: HTMLDivElement = document.createElement("div");
        $instructions.className = "trouteRoadbook__steps";
        return $instructions;
    }

    styleOnScroll($roadbookBody: HTMLDivElement): void {
        $roadbookBody?.addEventListener("scroll", () => {
            const scroll = $roadbookBody.scrollTop;
            if (scroll > 0) {
                $roadbookBody.classList.add("active");
            } else {
                $roadbookBody.classList.remove("active");
            }
        });
    }
    formatDistance(meters: number): string {
        if (meters < 1000) {
            return `${meters} m`;
        } else {
            return `${(meters / 1000).toFixed(2)} km`;
        }
    }

    formatTime(seconds: number): string {
        const minutes = Math.round(seconds / 60);
        if (minutes < 60) {
            return `${minutes} mins`;
        } else {
            const hours = Math.floor(minutes / 60);
            const remainingMinutes = minutes % 60;
            return `${hours} hours ${remainingMinutes} mins`;
        }
    }
    getTransitMode(mode: string): string {
        const transitModes = {
            train: [
                "highSpeedTrain",
                "intercityTrain",
                "interRegionalTrain",
                "regionalTrain",
                "cityTrain",
                "subway",
                "monorail",
                "inclined",
            ],
            tram: ["lightRail"],
            bus: ["bus", "privateBus", "busRapid"],
            ferries: ["ferry"],
            aerial: ["aerial", "flight", "spaceship"],
        };
        for (const key in transitModes) {
            if (transitModes[key].includes(mode)) {
                return replace(key, getLocale().directions.transit);
            }
        }
        return "pedestrian"; // or you can return 'unknown' or any other default value
    }


}
